import React, { useMemo } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import { usePrivacy } from '../../context/PrivacyContext';
import { getPrivacySections } from '../../content/privacyContent';
import '../../styles/privacy.css';

const PrivacyModal = ({ forceOpen = false, onCloseOverride = null, isStandalone = false }) => {
    const { language } = useLanguage();
    const { t } = useTranslation(language);
    const { isPrivacyModalOpen, closePrivacyModal } = usePrivacy();

    const sections = useMemo(() => getPrivacySections(language), [language]);

    const isOpen = forceOpen || isPrivacyModalOpen;

    const handleClose = () => {
        if (forceOpen && typeof onCloseOverride === 'function') {
            onCloseOverride();
        } else {
            closePrivacyModal();
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className={`privacy-overlay${isStandalone ? ' privacy-overlay--standalone' : ''}`} role="dialog" aria-modal="true">
            <div className="privacy-modal">
                <div className="privacy-modal__header">
                    <h2>{t('privacy.modalTitle')}</h2>
                    <button
                        type="button"
                        className="privacy-close"
                        onClick={handleClose}
                        aria-label={t('privacy.close')}
                    >
                        ×
                    </button>
                </div>

                <div className="privacy-modal__body">
                    {sections.map((section) => (
                        <section key={section.title} className="privacy-section">
                            <h3>{section.title}</h3>
                            {section.body && section.body.map((paragraph, idx) => (
                                <p key={idx}>{paragraph}</p>
                            ))}
                            {section.bullets && (
                                <ul>
                                    {section.bullets.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </section>
                    ))}
                </div>

                <div className="privacy-modal__footer">
                    <button type="button" className="primary-button" onClick={handleClose}>
                        {t('privacy.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyModal;

